import { useEffect } from "react";

export function useMouseWheel(
  cb: (e: WheelEvent) => void,
  scrollRef?: React.RefObject<HTMLElement>,
) {
  useEffect(() => {
    const wheelCallback = (e: WheelEvent) => {
      if (scrollRef) {
        if (
          scrollRef?.current &&
          scrollRef.current.contains(e.target as Node)
        ) {
          cb(e);
        }
      } else {
        cb(e);
      }
    };

    window.addEventListener("wheel", wheelCallback);

    return () => {
      window.removeEventListener("wheel", wheelCallback);
    };
  }, [cb, scrollRef]);
}
